"use client";
import { z } from 'zod';
import { AD_BUDGET_TYPES, BUSINESS_TYPES } from '@/app/models/BusinessType';
import { passwordSchema } from './SharedInputSchemas';
import clsx from 'clsx';
import glyphiconFont from '@/styles/glyphicon-font';
export default class ClientFormHelper {
    private state: any;

    public constructor(state: any) {
        this.state = state;
    }

    public getErrors(key: string, state: any = this.state): string[] {
        // Check for both 'errors' (plural) and 'error' (singular) for compatibility
        if (state && 'errors' in state && key in state.errors) {
            return (state as { errors: { [key: string]: string[] } }).errors[key];
        }
        if (state && 'error' in state && key in state.error) {
            return (state as { error: { [key: string]: string[] } }).error[key];
        }
        return [];
    }

    public hasErrors(key: string, state: any = this.state): boolean {
        return this.getErrors(key, state).length > 0;
    }

    // used for the inputs, selects, and textareas
    public hasErrorFeedback(key: string, className: string = 'has-error', state: any = this.state) {
        return this.hasErrors(key, state) ?
            clsx(
                className,
                "focus:border-[#843534]",
                "focus:shadow-[0_1px_1px_rgba(0,0,0,0.075)_inset,0_0_6px_#ce8483]",
            ) :
            clsx(
                "focus:border-[#2da1f8]",
                "focus:shadow-[0_1px_1px_rgba(0,0,0,0.075)_inset,0_0_6px_#2da1f8]",
            );
    }

    public hasErrorDetails(key: string, state: any = this.state) {
        return (this.hasErrors(key, state) &&
            <>
                <span className={clsx(
                    glyphiconFont.className,
                    "absolute",
                    "text-[#a94442]",
                    "right-[15px]",
                    "top-[30px]",
                )}>
                    &#xe014;
                </span>
                {
                    this.getErrors(key, state).map((error, index) => (
                        <small key={index} className={clsx(
                            "text-[#a94442]",
                            "text-[12px]",
                            "pt-[5px]",
                        )}> {error} </small>
                    ))
                }
            </>);
    }

    public static passwordSchema() {
        return passwordSchema();
    }

    public static adBudgetSchema() {
        return z.enum(AD_BUDGET_TYPES, {
            errorMap: () => {
                return { message: "Please enter a valid budget" }
            }
        });
    }

    public static businessTypeSchema() {
        return z.enum(BUSINESS_TYPES, {
            errorMap: () => {
                return { message: "Please enter a valid business type" }
            }
        });
    }
}